
<app-spinner *ngIf="!guardian"></app-spinner>

<div *ngIf="guardian" class="row">
       <div class="col-sm-3">
        <app-side-bar-guardian-home
        [guardian]="guardian"
        [target_student_user_id]="0"
        (regFinished)="reloadMainHomePage($event)">
      </app-side-bar-guardian-home>
       </div>
       <div class="col-sm-9">
           <app-guardian-main-area [guardian]="guardian"></app-guardian-main-area>
      </div>

</div>


